import { render, staticRenderFns } from "./ClientLogin.vue?vue&type=template&id=6405f504&scoped=true&"
import script from "./ClientLogin.vue?vue&type=script&lang=ts&"
export * from "./ClientLogin.vue?vue&type=script&lang=ts&"
import style0 from "./ClientLogin.vue?vue&type=style&index=0&id=6405f504&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6405f504",
  null
  
)

export default component.exports